var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00001 5C9.00001 4.44772 9.44772 4 10 4H20C20.5523 4 21 4.44772 21 5V7C21 7.55228 20.5523 8 20 8C19.4477 8 19 7.55228 19 7V6H13.8828L13.6173 8.12403C13.5488 8.67206 13.049 9.06078 12.501 8.99228C11.953 8.92378 11.5642 8.42399 11.6327 7.87597L11.8672 6H10C9.44772 6 9.00001 5.55228 9.00001 5ZM4.25671 4.83104C4.62617 4.42053 5.25846 4.38725 5.66897 4.75671L20.669 18.2567C21.0795 18.6262 21.1128 19.2585 20.7433 19.669C20.3738 20.0795 19.7416 20.1128 19.331 19.7433L12.7772 13.8448L11.9923 20.124C11.9238 20.6721 11.424 21.0608 10.876 20.9923C10.328 20.9238 9.93923 20.424 10.0077 19.876L10.9654 12.2143L4.33104 6.24329C3.92053 5.87384 3.88726 5.24155 4.25671 4.83104Z",
    fill: "#52525B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveStyle);
export default __webpack_public_path__ + "static/media/RemoveStyle.143fc3443568f01cf65e449b2d19636d.svg";
export { ForwardRef as ReactComponent };